export default "__VITE_ASSET__dOfs3HGx__"